<template>
  <div>
    <h1>Login</h1>
    <div>
      <input
        type="text"
        name="email"
        placeholder="email"
        v-model="email"
      />
      <input
        type="password"
        name="password"
        placeholder="password"
        v-model="password"
      />
      <button
        @click="register"
        v-bind:disabled="loading">
        Login
      </button>
    </div>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  name: 'Register',
  data () {
    return {
      email: 'enter email',
      password: 'enter password',
      loading: false
    }
  },
  methods: {
    async register () {
      this.loading = true
      const responce = await AuthenticationService.register({
        email: this.email,
        password: this.password
      })
      console.log(responce.data)
      this.loading = false
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Register.vue